var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-sticky-button__item",style:(_vm.getStyles)},[_c('m-icon',{attrs:{"name":_vm.icon,"size":_vm.currentIconSize,"color":_vm.currentIconColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }